import { z } from 'zod';

/** Evidence is one model for photos and videos (PLAN §2.4, D25). MVP creates photos only. */
export const EVIDENCE_MEDIA_TYPES = ['photo', 'video'] as const;
export type EvidenceMediaType = (typeof EVIDENCE_MEDIA_TYPES)[number];
export const evidenceMediaTypeSchema = z.enum(EVIDENCE_MEDIA_TYPES);

/** File extension used in the storage path (PLAN §2.8). */
export const EVIDENCE_FILE_EXTENSIONS: Readonly<Record<EvidenceMediaType, string>> = {
  photo: 'jpg',
  video: 'mp4',
};
